"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseMetaProps", {
    enumerable: true,
    get: function() {
        return BaseMetaProps;
    }
});
const _zod = require("zod");
const BaseMetaProps = _zod.z.strictObject({
    iconColor: _zod.z.string().optional(),
    showNullAndEmptyInFilter: _zod.z.boolean().optional()
});
